import React from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { Button } from '@styles/button.style'
import { Schema$GameBannerDetailButton } from '@interface/common'
import { BannerButtonWrap } from '@views/Popup/MatchupBanner/BannerButton/index.style'
import { GAME_BANNER_DETAIL_BUTTON_TYPE } from '@v2/constants/common'
import { isMobile } from 'react-device-detect'

interface BannerButtonProps {
  bannerButtonData: Schema$GameBannerDetailButton[]
}

export const BannerButton: React.FC<BannerButtonProps> = observer((props) => {
  const { bannerButtonData } = props
  const { componentStore } = useRootStore()

  const onClickGooglePlayBtn = () => {
    componentStore.deepLinkingChampPokerByAndroid()
  }

  const onClickAppStoreBtn = () => {
    componentStore.deepLinkingChampPokerByIOS()
  }

  const LinkBtn = ({ type, imageUrl }) => {
    if (!imageUrl) return null

    const handleClick = (type) => {
      switch (type) {
        case GAME_BANNER_DETAIL_BUTTON_TYPE.DOWNLOAD_AOS:
          onClickGooglePlayBtn()
          break
        case GAME_BANNER_DETAIL_BUTTON_TYPE.DOWNLOAD_IOS:
          onClickAppStoreBtn()
          break
        default:
          // do something
      }
    }

    return (
      <Button TP className="link-btn" onClick={() => handleClick(type)}>
        <img src={imageUrl} alt="다운로드 버튼" />
      </Button>
    )
  }

  return (
    <BannerButtonWrap className={!isMobile && 'pc'}>
      <p>다운로드 하러가기</p>
      {bannerButtonData.map((data, index) => (
        <LinkBtn key={index} type={data.buttonType} imageUrl={data.buttonImage} />
      ))}
    </BannerButtonWrap>
  )
})
